import React from 'react'
import pretty from '@st-operations/uikit/lib/pretty'

import './styles.scss'

const DetailsModal = ({ data = {}, actions = [] }) => {
  if (!data) return null
  return (
    <div className="apa-details-modal">
      <div className="apa-details-modal__data">
        {Object.entries(data).map(([key, value]) =>
          typeof value === 'object' ? null : (
            <div key={key}>
              <span>{pretty(key)}</span>
              <span>{value}</span>
            </div>
          )
        )}
      </div>
      <div className="apa-details-modal__actions">{actions}</div>
    </div>
  )
}

export default DetailsModal
